<template>
  <v-card :key="props.value.id">
    <v-toolbar :color="!props.value.online ? 'grey-lighten-1' : !props.value.power ? 'grey-darken-4' : 'primary'">
      <v-toolbar-title>{{ props.value.name }}</v-toolbar-title>
      <template #append>
        <v-btn icon="mdi-map-marker" @click.stop="onLocationPost" v-if="props.value.locationPost"></v-btn>
        <v-btn icon="mdi-map-marker-plus" @click.stop="onLocationPost" v-else-if="props.value.locationPostEditable"></v-btn>
      </template>
    </v-toolbar>
    <v-card-item>
      <div class="d-flex align-start" v-if="props.value.postWritable">
        <v-btn
            class="d-none mr-1" color="red-accent-4" variant="text" size="small" density="compact" icon="mdi-text-box-outline"
            @click.stop="onPosts"
        ></v-btn>
        <div class="flex-1-1">
          <v-scroll-y-reverse-transition mode="out-in" v-for="post in filteredPosts" v-if="0 < filteredPosts.length">
            <div
                class="flex-1-1 text-truncate text-subtitle-2"
                v-ripple
                style="color: #d50000;"
                :key="post.id"
                @click.stop="onPost(post)"
            >{{ post.subject }}</div>
          </v-scroll-y-reverse-transition>
          <div
              v-ripple
              class="text-truncate text-subtitle-2"
              style="color: #d50000;"
              @click.stop="onAddPost" v-else-if="props.value.postWritable"
          >
            등록된 메모 없음
          </div>
        </div>
        <v-btn
            color="red-accent-4" variant="text" size="small" density="compact" icon="mdi-plus" @click.stop="onAddPost"
            v-if="props.value.postWritable && 0 < filteredPosts.length"
        ></v-btn>
      </div>
    </v-card-item>
    <v-card-text v-if="props.value.descriptions">
      <div v-for="description in props.value.descriptions">{{ description }}</div>
    </v-card-text>
    <v-card-item v-if="props.value.online">
      <div class="d-flex align-center" style="margin: -8px;">
        <v-select
            density="compact" hide-details class="ma-2 flex-1-0" label="버튼"
            v-model="selectedButtonId"
            :items="props.value.buttons"
            item-title="name"
            item-value="id"
        ></v-select>
        <v-btn class="ma-2 mr-0 flex-0-0" style="min-width: 36px; width: 36px; height: 36px;" variant="tonal" @click="onSchedule">
          <v-icon>mdi-calendar-clock</v-icon>
        </v-btn>
        <v-btn class="ma-2 flex-0-0" style="min-width: 36px; width: 36px; height: 36px;" variant="tonal" :loading="props.value.loading" @click="onButton">
          <v-icon>mdi-check</v-icon>
        </v-btn>
      </div>
    </v-card-item>
  </v-card>
</template>

<script setup>

import {computed, onUnmounted, ref, watch} from "vue";
import {useDelayedStore} from "@/stores/delayed";

const props = defineProps(['value']);
const emit = defineEmits(['onLocationPost', 'onPosts', 'onPost', 'onAddPost', 'onButton']);

const delayedStore = useDelayedStore();

const postIndex = ref(0);
const selectedButtonId = ref(null);
const postInterval = ref(0);

const DISPLAY_POSTS_LENGTH = 3;

const posts = computed(() => props.value.posts);
const filteredPosts = computed(() => [...posts.value, ...posts.value]
    .slice(postIndex.value, postIndex.value + Math.min(DISPLAY_POSTS_LENGTH, posts.value.length))
);

watch(posts, (newValue, oldValue) => {
  if (JSON.stringify(newValue) === JSON.stringify(oldValue))
    return;

  if (0 < postInterval.value)
    clearInterval(postInterval.value);

  if (newValue && newValue.length <= DISPLAY_POSTS_LENGTH) {
    postIndex.value = 0;
    return;
  }

  postInterval.value = setInterval(() => {
    postIndex.value = newValue && 0 < newValue.length ? (postIndex.value + 1) % newValue.length : 0;
  }, 4_000);
}, {immediate: true});

const onLocationPost = () => emit('onLocationPost');
const onPosts = () => emit('onPosts');
const onPost = post => emit('onPost', post);
const onAddPost = () => emit('onAddPost');

const onSchedule = () => {
  const button = props.value.buttons.find(({id}) => id === selectedButtonId.value);
  if (!button)
    return alert('버튼을 선택하세요');

  (async () => {
    const operation = await delayedStore.showWithButton(button)
    if (!operation) return;

    const [hours, minutes] = delayedStore.delay === 'after'
        ? [delayedStore.afterHours, delayedStore.afterMinutes]
        : delayedStore.delay === 'at'
            ? [delayedStore.atHours, delayedStore.atMinutes]
            : [];

    if (isNaN(hours) || isNaN(minutes))
      return alert('입력값이 올바르지 않습니다.');

    const buttonId = selectedButtonId.value;
    selectedButtonId.value = null;

    emit('onButton', {delay: delayedStore.delay, hours, minutes, buttonId});
  })()
      .catch(error => console.log(error));
};

const onButton = () => {
  if (!selectedButtonId.value)
    return alert('버튼을 선택하세요');

  const buttonId = selectedButtonId.value;
  selectedButtonId.value = null;

  emit('onButton', {buttonId});
};

onUnmounted(() => {
  clearInterval(postInterval.value);
  postInterval.value = 0;
});

</script>

<style scoped>
</style>
